export class SearchSoftwareProductTransaction {
  constructor(data) {
    this.fromDate = data.fromDate;
    this.toDate = data.toDate;
    this.billNumber = data.billNumber;
    this.module = data.module ? data.module : 'request-keys';
    this.page = !isNaN(Number(data.page)) ? Number(data.page) : 1;
    this.size = !isNaN(Number(data.size)) ? Number(data.size) : 10;
  }
}
